import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class BillingsService {

  constructor(private http: HttpClient) { }

  getCurrentBill() {
    return this.http.get<any>(Library.API_ENDPOINT + 'billing/get_current_bill', OPTIONS);
  }

  getBills() {
    return this.http.get<any>(Library.API_ENDPOINT + 'billing/get_bills', OPTIONS);
  }

  getPaidBills() {
    return this.http.get<any>(Library.API_ENDPOINT + 'billing/get_paid_bills', OPTIONS);
  }

  xenditPay(amount: any, ID: any, successURL: any, failURL: any, connectedEmail: any, fname: any) {
    const queryParams = new HttpParams()
      .set('amount', amount)
      .set('successURL', successURL)
      .set('failURL', failURL)
      .set('email', connectedEmail)
      .set('fname', fname)
      .set('fee', 0)

    return this.http.post<any>(Library.API_ENDPOINT + `billing/xendit-create/${ID}`, {}, { params: queryParams })
  }

  getXenditSuccessURL(URL: string) {
    const params = new HttpParams().set('URL', URL);
    return this.http.get<any>(Library.API_ENDPOINT + 'billing/get_xendit_succcessURL', { params });
  }

  billPayment(ID: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `billing/complete_bill_payment/${ID}`, OPTIONS)
  }

  create_bill_payment(planID: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `billing/create_bill_payment/${planID}`, OPTIONS)
  }
}
